import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.04 5.2 15.96 12l-7.92 6.8",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "square"
	})
});
export default SvgChevronRight;
